// extracted by mini-css-extract-plugin
module.exports = {"notes":"FinePrintInfoCard_notes__1qNJr","notesText":"FinePrintInfoCard_notesText__2T53r","defaultFinePrintText":"FinePrintInfoCard_defaultFinePrintText__27jh5"};